// Alternative implementation using jQuery if available in your theme
// Save this as assets/cursor-tooltip.js

(function() {
  // Check if jQuery is available
  if (typeof jQuery !== 'undefined') {
    // jQuery implementation
    $(document).ready(function() {
      // Create tooltip element
      var $tooltip = $('<div class="tooltip"></div>').appendTo('body');
      
      // Handle mouse events
      $('.nav-icons li a').each(function() {
        // Get tooltip text
        var tooltipText = $(this).find('.tooltip-text').text();
        
        // Remove original tooltip element
        $(this).find('.tooltip-text').remove();
        
        // Store tooltip text as data attribute
        $(this).attr('data-tooltip', tooltipText);
        
        // Mouse events
        $(this)
          .on('mouseenter', function() {
            $tooltip.text($(this).data('tooltip')).show();
          })
          .on('mouseleave', function() {
            $tooltip.hide();
          })
          .on('mousemove', function(e) {
            $tooltip.css({
              top: e.pageY + 15,
              left: e.pageX + 15
            });
          });
      });
    });
  } else {
    // Vanilla JS implementation (for themes without jQuery)
    document.addEventListener('DOMContentLoaded', function() {
      // Create a single tooltip element to be reused
      const tooltip = document.createElement('div');
      tooltip.className = 'tooltip';
      document.body.appendChild(tooltip);
      
      // Select all nav icon links
      const navLinks = document.querySelectorAll('.nav-icons li a');
      
      // Add event listeners to each link
      navLinks.forEach(link => {
        // Find the tooltip text element
        const tooltipTextElement = link.querySelector('.tooltip-text');
        
        if (tooltipTextElement) {
          // Store the tooltip text in a data attribute
          const tooltipText = tooltipTextElement.textContent;
          link.setAttribute('data-tooltip', tooltipText);
          
          // Remove the original tooltip span
          tooltipTextElement.remove();
          
          // Show tooltip on mouseover
          link.addEventListener('mouseover', function() {
            tooltip.textContent = this.getAttribute('data-tooltip');
            tooltip.style.display = 'block';
          });
          
          // Hide tooltip on mouseout
          link.addEventListener('mouseout', function() {
            tooltip.style.display = 'none';
          });
          
          // Update tooltip position on mousemove
          link.addEventListener('mousemove', function(e) {
            // Position tooltip near cursor with a small offset
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });
        }
      });
    });
  }
})();